export enum KeyNodeTitle {
  SKD = 'SKD',
  SLM = 'SLM',
  MASTER_KEYS = 'MASTER_KEYS',
  CHANGE_KEYS = 'CHANGE_KEYS',
  DELETE_KEYS = 'DELETE_KEYS',
  MOVE_KEYS = 'MOVE_KEYS',
  DIRECT_CHANGES_NODE = 'DIRECT_CHANGES_NODE',
  CONSTRUCTION_KEYS = 'CONSTRUCTION_KEYS',
  CONTROL_KEYS = 'CONTROL_KEYS',
}
